module.exports = __webpack_public_path__ + "static/media/confirm-popup.382c7ac0.png";